import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollProgress } from './components/ScrollProgress';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { CaseStudy } from './pages/CaseStudy';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31aqfuglwour9">
      <ScrollToTop data-id="element-1" data-mp="31b8lu4ydencd" />
      <div className="flex min-h-screen w-full flex-col bg-ink font-sans text-cream" data-id="element-2" data-mp="31brzh9gzmpkl">
        <ScrollProgress data-id="element-3" data-mp="2wjqft2hhpwkj" />
        <Header data-id="element-4" data-mp="2wiffxdr618yp" />
        <main className="flex-1" data-id="element-5" data-mp="2whx8rm2ytac0">
          <Routes data-id="element-6" data-mp="28u5uwe1s0p8m">
            <Route path="/" element={<Home data-id="element-8" data-mp="28suw6sn6u7od" />} data-id="element-7" data-mp="28tmifcuwat1z" />
            <Route path="/work" element={<Work data-id="element-10" data-mp="23vkzqt1dsvr1" />} data-id="element-9" data-mp="28sbe9bxjfjac" />
            <Route path="/work/:slug" element={<CaseStudy data-id="element-12" data-mp="23v2uj6wqr76z" />} data-id="element-11" data-mp="23u9ueosaffxt" />
            <Route path="/about" element={<About data-id="element-14" data-mp="3ikqwvtvkeu33" />} data-id="element-13" data-mp="3ijxsgzk2wgo4" />
            <Route path="/contact" element={<Contact data-id="element-16" data-mp="3ii4qvyobommz" />} data-id="element-15" data-mp="3ijfv1zlojwem" />
            <Route path="*" element={<Home data-id="element-18" data-mp="3mkhofzsx1e8o" />} data-id="element-17" data-mp="3ml1397n9rmih" />
          </Routes>
        </main>
      </div>
    </BrowserRouter>;
}